import type { CatalogAssetResponse } from "../../generated/api/types.gen";
import { AssetThumbnailImage } from "../gallery/GalleryAssetGrid";

/**
 * A product's swatch (its hex for a color) or photo, with its catalog category
 * as a tag in the top-right corner (never the supplier's own label) unless
 * ``showCategory`` is off. Sized by the caller.
 */
export function SourceAssetSwatch({
  asset,
  className,
  showCategory = true,
}: {
  asset: CatalogAssetResponse;
  className: string;
  showCategory?: boolean;
}) {
  return (
    <div
      className={`relative flex flex-col items-end overflow-hidden rounded-lg p-3 ${className}`}
      style={
        asset.type === "color" ? { backgroundColor: asset.value } : undefined
      }
    >
      {asset.type === "image" && (
        <div className="absolute inset-0 overflow-hidden rounded-lg bg-white">
          {/* Blurred fill of the photo itself: supplier backdrops vary per
          image (white, grey gradients), so this self-matches where a fixed
          matte cannot. */}
          <img
            alt=""
            aria-hidden="true"
            src={asset.value}
            className="absolute inset-0 h-full w-full scale-110 object-cover blur-2xl"
          />
          {/* Contain, not cover: supplier photos are often portrait and
          cover would crop the fixture. */}
          <AssetThumbnailImage
            src={asset.value}
            className="relative h-full w-full"
            fit="contain"
          />
        </div>
      )}
      {showCategory && asset.catalog_category && (
        <span className="relative rounded-[36px] bg-white/60 px-2.5 py-0.5 text-[9px] leading-5 font-semibold whitespace-nowrap text-[#20262c]">
          {asset.catalog_category}
        </span>
      )}
    </div>
  );
}
